module.exports = __webpack_public_path__ + "static/img/anLiBoxImg4.b0289a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anLiBoxImg4.png
// module id = fLGD
// module chunks = 2